// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__1wdu2","Open":"SideDrawer_Open__17sQc","Close":"SideDrawer_Close__1YVWJ","Logo":"SideDrawer_Logo__2E8Gi"};